<script setup>
import {computed, ref} from 'vue';
import http from '@/http';
import 'flag-icons/css/flag-icons.min.css';

const props = defineProps({locale: String})
const currentLocale = ref(props.locale || 'cs')

const languages = {
  cs: {label: 'Čeština', code: 'cz'},
  en: {label: 'English', code: 'gb'},
};

const changeLanguage = (lang) => {
  http.post('/set-locale', {locale: lang}).then(() => {
    // změna ve Vue
    //locale.value = currentLocale.value
    localStorage.setItem('lang', lang);
    location.reload();
  }).catch((error) => {
    console.error('Error setting locale:', error);
  });
  /* locale.value = lang;
  localStorage.setItem('lang', lang); // Uložení do localStorage*/
};
</script>

<template>
  <div class="language-switcher">
<!--    <div class="d-none d-md-block" v-for="(lang, code) in languages">
      <button class="btn me-3" type="button" :key="code"
              @click="changeLanguage(code)"
              :class="currentLocale === code ? 'btn-primary' : 'btn-secondary'"><h3 class="mb-0">{{ lang.flag }}</h3></button>
    </div>-->
    <div class="dropdown">
      <button class="btn btn-primary bg-transparent dropdown-toggle d-flex align-items-center me-3"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false">
        <span class="fi me-2" :class="`fi-${languages[currentLocale].code}`"></span>
      </button>
      <ul class="dropdown-menu">
        <li v-for="(lang, code) in languages" :key="code">
          <a class="dropdown-item d-flex align-items-center"
             href="#"
             @click.prevent="changeLanguage(code)">
            <span class="fi me-2" :class="`fi-${lang.code}`"></span> {{ code.toUpperCase() }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>


<style scoped lang="scss">
.language-switcher {
  display: flex;
  gap: 10px;
}

button {
  padding: 5px 10px;
  cursor: pointer;
  border: 1px solid var(--color-border);
}

button.active {
  cursor: none;
  background: var(--primary);
}
</style>